module.exports = __webpack_public_path__ + "static/cf-reg-italic-3a8d470922a46ceae44967da89763543.ttf";